import React,{useState} from 'react';
import {Form,Col,Container,Table} from 'react-bootstrap';


function AnswerField(props){
   
    let answers = props.answers
   
    const [value,setVal] = useState(answers[0][0])
   
    const handleAnswer =  (e) =>{
       setVal(e.target.value)
       
  
        props.handler(e)

    }
    const event_name = props.name.toString()
    
        return(
            
        <Form.Group as={Col}>
                
                <Form.Control as={"select"} onChange={handleAnswer} name={event_name} value={value} disabled={props.disabled}>
                        {answers.map((answer,index) =>(
                            <option key={index} score={answer[1]}>{answer[0]}</option>))}
                </Form.Control>
            </Form.Group>
    
        )
    }

AnswerField.defaultProps ={
    useScore:false
}
function getAnswerIndex(array,answer){
    
    for (var i =0; i<array.length;i++){
        
       
            var index = array[i].indexOf(answer);
            if(index> -1){
                return i;
            }
        
        
        
    }
}
function AnswerField_Score(props){
    const event_name = props.name.toString()
    let answers = props.answers
    var scoreIndex;
    if(props.data!=null){
        scoreIndex =getAnswerIndex(answers,props.data)
    }
    
    
    const [changed,triggerChange] = useState(props.data!=null?true:false)
    const [previous,setPrevious] = useState(props.data!=null?answers[scoreIndex][1]:0)
    const [modPrevious,setModPrevious] = useState(props.data!=null?answers[scoreIndex][2]:0)
    const [value,setVal] = useState(props.data!=null?props.data:answers[0][0])

   
    const handleAnswer =  (e) =>{
        var score = parseInt(answers[e.target.selectedIndex][1])
        var modified_score = parseInt(answers[e.target.selectedIndex][2])
       setVal(e.target.value)
       if (changed){
            props.score(-previous,-modPrevious)
            props.score(score,modified_score)
            setPrevious(score)
            setModPrevious(modified_score)
            

       }
       else{
      
            
            setPrevious(score)
            setModPrevious(modified_score)
            triggerChange(true)
            props.score(score,modified_score)
            
        }
        props.handler(e)
        setVal(e.target.value)

    }
    
        return(
            
        <Form.Group as={Col}>
                
                <Form.Control as={"select"} onChange={handleAnswer} name={event_name} value={value} disabled={props.disabled}>
                        {answers.map((answer,index) =>(
                            <option key={index} score={answer[1]}>{answer[0]}</option>))}
                </Form.Control>
            </Form.Group>
    
        )
    }



class Questions_Table extends React.Component {
    constructor(props){
        super(props)
        this.state = {score:0}
        
    }
    Scoring = async (val)=> {
       
        
        if (!isNaN(val)){
             await this.setState((prevState) => 
                         ({
                             ...prevState,
                             score:prevState.score + (val)
 
                         })
                         
             )
         }
         
     }
    onChange = async (event,score_val)=>{
        const {name,value} = event.target
        await this.setState((prevState)=>({
            ...prevState,
            [name]: value,
            score:prevState.score + score_val
        }))
     }
    // componentDidUpdate(prevProps,prevState){
    //     if (prevState != this.state){
    //         this.props.handler(this.props.fieldName,this.state)
    //     }
    // }
    render(){
        let questions = this.props.questions
        
        return(
            <Table responsive={true} bordered={false} size="md" hover={true} striped={false}>
                {!this.props.hideHeader&& <thead>
                        <tr>
                            
                            <th>Question</th>
                            <th>Answer</th>
                        </tr>
                </thead>}
                <tbody>
                    {questions.map((question,index)=>(
                        <tr key={index}>
                            <th>{index+1}.{question.title}</th>
                           <th width={400}> {this.props.score
                                ? 
                                <AnswerField_Score name={question.name} disabled={this.props.disabled}data={this.props.data!=null?this.props.data[question.name]:null} handler={this.props.handler} answers={question.answers} fieldName={this.props.fieldName} score={this.props.scoreFunc}/>
                                
                                :<AnswerField name={question.name} disabled={this.props.disabled } handler={this.props.handler} answers={question.answers} fieldName={this.props.fieldName}/>}</th>
                        </tr>
                    ))}
                </tbody>
            </Table>
        )
    }
    
}
Questions_Table.defaultProps = {
    Scoring:false,
    score:null,
    hideHeader:false,
    data:null,
    disabled:false
}


export default Questions_Table;